var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myself",staticClass:"contact-list-item relative",class:{
    'chosen': _vm.contact.id === _vm.contactIdParam,
  },attrs:{"data-has-messages":_vm.contact.unread_messages !== 0 ? 'yes' : 'no'},on:{"click":_vm.showContact}},[(_vm.isVisible)?_c('person',{attrs:{"contact":_vm.contact,"person-type":"default"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }